<template>
  <div class="container-fluid">
    <div class="row d-flex justify-content-center">
      <div class="col-lg-10">
        <h1 class="heading-color text-center p-5">Advertisements</h1>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.$store.getters.apiStatus !== 'loading'">
      <div class="col-lg-10">
        <div class="overlay">
          <div class="main-loader">
            <MainLoader></MainLoader>
          </div>
        </div>
        <div class="row">
          <ItemCard v-for="item in items" :key="item.id" :item="item" :nextLink="'download/advertisement/' + item.id"></ItemCard>
        </div>
      </div>
    </div>
    <div class="main-loader" v-else>
      <MainLoader></MainLoader>
    </div>
  </div>
</template>

<script>
import ItemCard from '@/components/ItemCard'
export default {
  name: 'Advertisements',
  components: {
    ItemCard
  },
  data () {
    return {
      items: null
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    fetch () {
      this.items = []
      $('.overlay').removeClass('d-none')
      this.$store.dispatch('fetchAdvertisements')
        .then((result) => {
          this.items = result.data.advertisements
          $('.overlay').addClass('d-none')
        })
        .catch((err) => this.$helper.catchHandler(err))
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Advertisements.vue